/* Preserve native purchasing; reserve the measured bar height and yield to dialogs. */
(() => {
  const html = document.documentElement;
  const observed = new Set();
  let scheduled = false;
  const visible = node => node instanceof HTMLElement && !node.hidden &&
    getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden' &&
    node.getBoundingClientRect().width > 0 && node.getBoundingClientRect().height > 0;
  const queue = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
  const update = () => {
    scheduled = false;
    const bars = [...document.querySelectorAll('.product-quick-add')];
    for (const bar of bars) {
      if (!observed.has(bar)) { observed.add(bar); resize?.observe(bar); }
    }
    for (const bar of observed) {
      if (!bar.isConnected) { resize?.unobserve(bar); observed.delete(bar); }
    }
    const height = Math.ceil(Math.max(0, ...bars.map(bar => bar.getBoundingClientRect().height)));
    const reserve = `${height}px`;
    if (html.style.getPropertyValue('--bp26-buybar-height') !== reserve) {
      html.style.setProperty('--bp26-buybar-height', reserve);
    }
    const overlays = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, dialog[open], [aria-modal="true"], .drawer[open], .modal[open]');
    const focus = document.activeElement;
    const typing = focus instanceof HTMLElement && focus.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, select, [contenteditable="true"]') && !focus.closest('.product-quick-add');
    const blocked = [...overlays].some(visible) || (matchMedia('(max-width: 749px)').matches && typing);
    const value = blocked ? 'true' : 'false';
    if (html.dataset.bp26Overlay !== value) html.dataset.bp26Overlay = value;
    // The native observer can initialise before the deferred footer or variant form exists.
    // Resolve the current DOM on each queued update, including after a variant re-render.
    const footer = document.querySelector('.footer');
    const footerRect = footer?.getBoundingClientRect();
    const footerVisible = footerRect && footerRect.top < innerHeight && footerRect.bottom > 0;
    for (const bar of bars) {
      const form = document.getElementById(bar.getAttribute('form'));
      const submit = form?.querySelector('button[type="submit"]');
      const show = !!form && !!submit && !submit.disabled &&
        form.getBoundingClientRect().bottom < 0 && !footerVisible && !blocked;
      bar.toggleAttribute('data-bp26-visible', show);
    }
  };
  new MutationObserver(queue).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['open','hidden','style','class','aria-modal']});
  window.addEventListener('resize', queue, {passive:true});
  window.addEventListener('scroll', queue, {passive:true});
  window.visualViewport?.addEventListener('resize', queue, {passive:true});
  document.addEventListener('focusin', queue);
  document.addEventListener('focusout', queue);
  document.addEventListener('shopify:section:load', queue);
  update();
})();

// Close the focused navigation disclosure with Escape and return focus to its summary.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const disclosure = event.target.closest('.bp26-nav details[open]');
  if (!disclosure) return;
  disclosure.open = false;
  disclosure.querySelector('summary')?.focus();
  event.stopPropagation();
});

// The base theme scrolls anchor links without transferring keyboard focus.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('a.skip-to-content[href="#main"]')) return;
  const main = document.getElementById('main');
  if (!main) return;
  event.preventDefault();
  main.focus({preventScroll:true});
  main.scrollIntoView({block:'start', behavior:'instant'});
});

